import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { UpdateUserAccessibilityRequestModel } from '@/modules/user/models/user-request.model'

@vservice()
export class AdminUpdateUserAccessibilityUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminUserService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(userId: number, data: UpdateUserAccessibilityRequestModel) {
    return this.service.updateAccessibility(userId, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
